._scrollableEditorStage_n1oyd_1 {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden; }
  ._scrollableEditorStage_n1oyd_1._mainThreadScroll_n1oyd_8 {
    background-attachment: fixed;
    background-image: url(data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==); }
  ._scrollableEditorStage_n1oyd_1._scrollingDisabled_n1oyd_11 {
    overflow: hidden; }
  ._scrollableEditorStage_n1oyd_1._truncated_n1oyd_13 {
    width: calc( 100% + var(--stage-right-margin) + var(--stage-scrollbar-width)); }
  ._scrollableEditorStage_n1oyd_1._fixed_n1oyd_15, ._scrollableEditorStage_n1oyd_1._scrollingDisabled_n1oyd_11._fixed_n1oyd_15 {
    box-sizing: border-box;
    width: 100%;
    overflow: visible; }
    ._scrollableEditorStage_n1oyd_1._fixed_n1oyd_15._zoomMode_n1oyd_19 ._scrollableEditorStageContent_n1oyd_19, ._scrollableEditorStage_n1oyd_1._scrollingDisabled_n1oyd_11._fixed_n1oyd_15._zoomMode_n1oyd_19 ._scrollableEditorStageContent_n1oyd_19 {
      width: var(--stage-fixed-width); }
  ._scrollableEditorStage_n1oyd_1 ._scrollableEditorStageContent_n1oyd_19 {
    height: 100%;
    width: var(--stage-fixed-width);
    margin: 0 auto;
    position: relative; }
